(function () {
  var chrome = document.querySelector('.site-chrome') || document.querySelector('.site-nav');
  var rail = document.querySelector('.home-rail');
  var mini = document.querySelector('.pdp-mini');
  var root = document.documentElement;
  var ticking = false;

  function chromeOffset() {
    var navH = chrome ? Math.round(chrome.getBoundingClientRect().height) : 52;
    var railH = 0;
    if (rail) {
      var box = rail.getBoundingClientRect();
      if (box.height > 0 && box.top >= -1 && box.top <= navH + 4) {
        railH = Math.round(box.height);
      }
    }
    return Math.max(0, navH + railH - 2);
  }

  function measure() {
    var navH = chrome ? Math.round(chrome.getBoundingClientRect().height) : 52;
    root.style.setProperty('--nav-h', navH + 'px');
    var railH = 0;
    if (rail) {
      var box = rail.getBoundingClientRect();
      if (box.height > 0 && Math.abs(box.top - navH) <= 3) {
        railH = Math.round(box.height);
      }
    }
    root.style.setProperty('--rail-h', railH + 'px');
  }

  function goHash(hash, focusSignup) {
    if (!hash || hash.charAt(0) !== '#') return;
    var id = decodeURIComponent(hash.slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    measure();
    var pin = el;
    if (el.classList.contains('signup')) {
      pin = el.querySelector('.signup__title') || el;
    }
    var top = window.scrollY + pin.getBoundingClientRect().top - chromeOffset();
    if (el.classList.contains('signup') && pin !== el) top -= 28;
    if (top < 0) top = 0;
    window.scrollTo(0, top);
    if (focusSignup && (id === 'signup' || el.classList.contains('signup'))) {
      var input = el.querySelector('input[type="email"]');
      if (input) {
        try { input.focus({ preventScroll: true }); }
        catch (err) { input.focus(); }
      }
    }
  }

  function markRail() {
    var bar = mini || rail;
    if (!bar) return;
    var links = bar.querySelectorAll('a[href^="#"]');
    if (!links.length) return;
    var line = chromeOffset();
    var best = null;
    var bestTop = -Infinity;
    for (var i = 0; i < links.length; i++) {
      var id = links[i].getAttribute('href').slice(1);
      if (!id) continue;
      var el = document.getElementById(id);
      if (!el) continue;
      var top = el.getBoundingClientRect().top;
      if (top <= line + 48 && top > bestTop) {
        bestTop = top;
        best = links[i];
      }
    }
    for (var j = 0; j < links.length; j++) {
      var on = links[j] === best;
      links[j].classList.toggle('is-now', on);
      if (on) links[j].setAttribute('aria-current', 'location');
      else links[j].removeAttribute('aria-current');
    }
    if (best && best.scrollIntoView) {
      var barBox = bar.getBoundingClientRect();
      var chromeBottom = chrome ? chrome.getBoundingClientRect().bottom : 80;
      if (barBox.height > 0 && barBox.top >= -1 && barBox.top <= chromeBottom + 4) {
        best.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      }
    }
  }

  function tick() {
    ticking = false;
    measure();
    markRail();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(tick);
  }

  function bootStickyBar() {
    var bar = document.querySelector('.pdp-sticky');
    if (!bar) return;
    var armed = false;
    function onBar() {
      var y = window.scrollY || document.documentElement.scrollTop;
      var need = y > Math.min(420, window.innerHeight * 0.55);
      if (need !== armed) {
        armed = need;
        document.body.classList.toggle('is-sticky-on', need);
      }
    }
    window.addEventListener('scroll', onBar, { passive: true });
    onBar();
  }

  function bootJoinBar() {
    var bar = document.querySelector('[data-join-bar]');
    if (!bar) return;
    var listed = false;
    var dismissed = false;
    try {
      listed = localStorage.getItem('rumor_listed') === '1';
      dismissed = sessionStorage.getItem('rumor_join_dismissed') === '1';
    } catch (err) {}
    if (listed || dismissed) {
      document.body.classList.add('is-listed');
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    document.body.classList.add('has-join-bar');
    var x = bar.querySelector('[data-join-dismiss]');
    if (x) {
      x.addEventListener('click', function () {
        bar.hidden = true;
        document.body.classList.remove('has-join-bar');
        try { sessionStorage.setItem('rumor_join_dismissed', '1'); } catch (err) {}
      });
    }
  }

  function boot() {
    measure();
    markRail();
    bootJoinBar();
    function land() {
      measure();
      if (location.hash) goHash(location.hash, true);
      markRail();
    }
    land();
    window.addEventListener('load', land);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(land);
    setTimeout(land, 80);
    setTimeout(land, 320);
    document.addEventListener('click', function (event) {
      var a = event.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#') return;
      var id = href.slice(1);
      if (!document.getElementById(id)) return;
      event.preventDefault();
      if (history.pushState) history.pushState(null, '', href);
      else location.hash = href;
      goHash(href, true);
      markRail();
    });
    window.addEventListener('hashchange', function () {
      goHash(location.hash, true);
      markRail();
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (window.ResizeObserver && chrome) {
      new ResizeObserver(onScroll).observe(chrome);
    }
    bootStickyBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
